import React, { Fragment } from 'react';
import ElementsConfigureTable from './ElementsConfigureTable';

const PatientConfig: React.FC<{
    configTableTitle: string;
    elements: any;
    updateElemets: (elements: any[]) => void;
    onSave: () => void;
    closeMe: () => void;
}> = ({ configTableTitle, elements, updateElemets, onSave, closeMe }) => {
    return (
        <Fragment>
            <div className="p-16 flex flex-col flex-1 space-y-16 h-full overflow-auto">
                <div className="p-16 rounded-8 bg-white space-y-8">
                    <p className="body-1 bold text-darwin-neutral-1000">{configTableTitle}</p>
                    <ElementsConfigureTable config={elements} onUpdate={updateElemets} />
                </div>
            </div>

            <div className="flex items-center justify-between px-16 py-8 space-x-8 border-t border-neutral-7">
                <div>
                    <button onClick={closeMe} className="neutral-btn btn--small px-16 py-8">
                        <span className="w-full text-center">Cancel</span>
                    </button>
                </div>
                <div>
                    <button
                        onClick={onSave}
                        className="primary-btn  px-12 py-8 btn btn--small space-x-8"
                    >
                        <span className="w-full text-center">Save</span>
                    </button>
                </div>
            </div>
        </Fragment>
    );
};

export default PatientConfig;
